import { RouteRecordRaw } from 'vue-router';
import { IRouteMeta } from '@/core/models/routing';
import { AppCoreEnums } from '@/core/shared/enums';
import { useSupportStore } from '@/stores';
import { AppPermissions } from '@/shared/permissions';

const ROUTE_SUPPORT_ROOT = 'support-root';
const ROUTE_SUPPORT = 'support';
const ROUTE_SUPPORT_DETAILS = 'support-details';
const ROUTE_SUPPORT_OVERVIEW = 'support-overview';

const supportRoutes: RouteRecordRaw = {
  name: ROUTE_SUPPORT,
  path: ROUTE_SUPPORT,
  component: () => import('src/pages/support/support-page.vue'),
  meta: <IRouteMeta>{
    resolve: () => Promise.all([useSupportStore().getSupportData()]),
    containerType: AppCoreEnums.ContainerType.CollapsibleTableContainer,
    fullPageScroll: true,
    permissions: {
      writePermission: AppPermissions.SupportWrite,
    },
  },
};

export { supportRoutes, ROUTE_SUPPORT, ROUTE_SUPPORT_ROOT, ROUTE_SUPPORT_DETAILS, ROUTE_SUPPORT_OVERVIEW };
